/**
 *
 * @module lineItem
 *
 */

import Check from 'check-types';

import LineItemAttribute from './lineItemAttribute';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    string,
    array
} = Check.assert;

/**
 *
 * @class LineItem
 *
 */
export default class LineItem {

    /**
     *
     * @param {String} sku
     * @param {Array<LineItemAttribute>} [lineItemAttributes]
     * @throws {InvalidArgumentException}
     * @note params out of order with spec to keep optional items at the end
     *
     */
    constructor(sku, lineItemAttributes) {

        const errorMessage = {
            ctor: 'LineItem(sku, lineItemAttributes)',
            get sku() {
                return `${this.ctor} sku should be a String`;
            },
            get lineItemAttributes() {
                return `${this.ctor} needs lineItemAttributes Array`;
            }
        };

        string(sku, errorMessage.sku, InvalidArgumentException);

        if (Check.nonEmptyArray(lineItemAttributes)) {
            array.of.instanceStrict(
                lineItemAttributes,
                LineItemAttribute,
                errorMessage.lineItemAttributes,
                InvalidArgumentException
            );
        }

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.sku = sku;

        /**
         *
         * @access public
         * @type {Array<LineItemAttribute>}
         *
         */
        this.lineItemAttributes = lineItemAttributes;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/lineItem.js